// Fix the confict suggestion search in Debut theme
if (typeof theme !== 'undefined' && theme.hasOwnProperty('settings')) theme.settings.predictiveSearchEnabled = false;
// Override Settings
var boostPFSFilterConfig = {
	general: {
		limit: boostPFSThemeConfig.custom.products_per_page,
		// Optional
		loadProductFirst: false,
		styleScrollToTop: 'style2',
		defaultDisplay: boostPFSThemeConfig.custom.layout,
		showPlaceholderProductList: true,
		paginationTypeAdvanced: false,
      	enableKeepScrollbackPosition: false,
	},
};

(function() {
	BoostPFS.inject(this);

	ProductGridItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/

		// Get Template
		var itemHtml = boostPFSTemplate.productGridItemHtml;
		// Add a specific class for grid item
		var itemGridWidthClass = '';
		var imageSize = '600x600';

		switch (boostPFSConfig.custom.products_per_row) {
			case 2:
				itemGridWidthClass = 'medium-up--one-half';
				imageSize = '540x600';
				break;
			case 3:
				itemGridWidthClass = 'small--one-half medium-up--one-third';
				imageSize = '345x550';
				break;
			case 4:
				itemGridWidthClass = 'small--one-half medium-up--one-quarter';
				imageSize = '250x';
				break;
			case 5:
				itemGridWidthClass = 'small--one-half medium-up--one-fifth';
				imageSize = '195x';
				break;
		}
		itemHtml = itemHtml.replace(/{{itemGridWidthClass}}/g, itemGridWidthClass);

		// Add soldOut class
		var itemSoldOutClass = soldOut ? boostPFSTemplate.soldOutClass : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutClass}}/g, itemSoldOutClass);

		// Add soldOut label
		var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelGridHtml : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

		var imgId = 'ProductCardImage-' + data.id;
		var wrapperId = 'ProductCardImageWrapper-' + data.id;

		// Build Image style
		var imageStyle = buildImageStyle(data);
		itemHtml = itemHtml.replace(/{{imageStyle}}/g, imageStyle);

		// Add Images
		var aspect_ratio = '';
		var itemImagesHtml = '<div id="' + wrapperId + '" class="grid-view-item__image-wrapper js">';
		itemImagesHtml += '<div style="padding-top:';
		if (images.length > 0) {
			aspect_ratio = images[0]['width'] / images[0]['height'];
			itemImagesHtml += 1 / aspect_ratio * 100;
		} else {
			itemImagesHtml += 100;
		}
		itemImagesHtml += '%;">';
		itemImagesHtml += '<img id="' + imgId + '" ' +
			'class="grid-view-item__image easyOverlayImage lazyload" ' +
			'data-product_id="' + data.id + '"' +
			'src="' + Utils.getFeaturedImage(images, '300x300') + '" ' +
			'data-src="' + Utils.getFeaturedImage(images, '{width}x') + '" ' +
			'data-widths="[180, 300, 360, 540, 720, 900, 1080, 1296, 1512, 1728, 2048]" ' +
			'data-aspectratio="' + aspect_ratio + '" ' +
			'data-sizes="auto" ' +
			'alt="{{itemTitle}}">';
		itemImagesHtml += '</div>';
		itemImagesHtml += '</div>';

		var image_size = boostPFSConfig.custom.max_height + 'x' + boostPFSConfig.custom.max_height;
		var max_width = images.length > 0 ? boostPFSConfig.custom.max_height * aspect_ratio : 0;
		itemImagesHtml += '<noscript><img class="jjj grid-view-item__image easyOverlayImage" data-product_id="' + data.id + '" src="' + Utils.getFeaturedImage(images, image_size + '@2x') + '" alt="{{itemTitle}}" style="max-width: ' + max_width + 'px;"></noscript>';
		itemHtml = itemHtml.replace(/{{itemImages}}/g, itemImagesHtml);

		// Add Vendor
		var itemVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorGridHtml : '';
		itemHtml = itemHtml.replace(/{{itemVendor}}/g, itemVendorHtml);

		// Add Price
		var itemPriceHtml = buildPrice(data, onSale, priceVaries);
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		// Add preorder indicator
		var preOrderHtml = buildPreorderIndicator(data);
		itemHtml = itemHtml.replace(/{{preOrderIndicator}}/g, preOrderHtml);

		// Add special order
		var specialOrder = buildSpecialOrder(data);
		itemHtml = itemHtml.replace(/{{specialOrder}}/g, specialOrder);

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemId}}/g, data.id);
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

    var changePositionClass = '';
    if (data.compare_at_price_max > data.price_min) {
      var savePercent = ((data.compare_at_price_max - data.price_min) / data.compare_at_price_max) * 100;
      savePercent = Math.round(savePercent)
      itemHtml = itemHtml.replace(/{{saleTag}}/g, '<label class="product-label sale-tag">Save ' + savePercent + '%</label>');
      changePositionClass = ' inventory-tag-with-sale';
    } else {
      itemHtml = itemHtml.replace(/{{saleTag}}/g, '');
    }
    var itemQty = 0;
    data.variants.forEach(function(variant) {
      itemQty += variant.inventory_quantity;
    });
    if (itemQty > 0 && itemQty <= 5) {
      itemHtml = itemHtml.replace(/{{inventoryTag}}/g, '<label class="product-label inventory-tag' + changePositionClass + '">Low Stock</label>');
    } else {
      itemHtml = itemHtml.replace(/{{inventoryTag}}/g, '');
    }
		return itemHtml;
	}

	ProductListItem.prototype.compileTemplate = function(data) {
		if (!data) data = this.data;
		/*** Prepare data ***/
		var images = data.images_info;
		// Displaying price base on the policy of Shopify, have to multiple by 100
		var soldOut = !data.available; // Check a product is out of stock
		var onSale = data.compare_at_price_min > data.price_min; // Check a product is on sale
		var priceVaries = data.price_min != data.price_max; // Check a product has many prices
		// Get First Variant (selected_or_first_available_variant)
		var firstVariant = data['variants'][0];
		if (Utils.getParam('variant') !== null && Utils.getParam('variant') != '') {
			var paramVariant = data.variants.filter(function(e) {
				return e.id == Utils.getParam('variant');
			});
			if (typeof paramVariant[0] !== 'undefined') firstVariant = paramVariant[0];
		} else {
			for (var i = 0; i < data['variants'].length; i++) {
				if (data['variants'][i].available) {
					firstVariant = data['variants'][i];
					break;
				}
			}
		}
		/*** End Prepare data ***/

		// Get Template
		var itemHtml = boostPFSTemplate.productListItemHtml;

		// Add onSale label
		var itemSaleLabel = onSale ? boostPFSTemplate.saleLabelListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSaleLabel}}/g, itemSaleLabel);

		// Add soldOut label
		var itemSoldOutLabel = soldOut ? boostPFSTemplate.soldOutLabelListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSoldOutLabel}}/g, itemSoldOutLabel);

		// Add Thumbnail
		var itemThumbUrl = images.length > 0 ? Utils.optimizeImage(images[0]['src'], '600x600') : boostPFSConfig.general.no_image_url;
		itemHtml = itemHtml.replace(/{{itemThumbUrl}}/g, itemThumbUrl);

		// Add Vendor
		var itemSmallVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorSmallListHtml : '';
		itemHtml = itemHtml.replace(/{{itemSmallVendor}}/g, itemSmallVendorHtml);
		var itemMediumVendorHtml = boostPFSConfig.custom.vendor_enable ? boostPFSTemplate.vendorMediumListHtml : '';
		itemHtml = itemHtml.replace(/{{itemMediumVendor}}/g, itemMediumVendorHtml);

		// Add Price
		var itemPriceHtml = buildPrice(data, onSale, priceVaries);
		itemHtml = itemHtml.replace(/{{itemPrice}}/g, itemPriceHtml);

		// Add main attribute
		itemHtml = itemHtml.replace(/{{itemTitle}}/g, data.title);
		itemHtml = itemHtml.replace(/{{itemVendorLabel}}/g, data.vendor);
		itemHtml = itemHtml.replace(/{{itemUrl}}/g, Utils.buildProductItemUrl(data));

		return itemHtml;
	}

	// Build Image style
	function buildImageStyle(data) {
		var images = data.images_info;
		var imgId = 'ProductCardImage-' + data.id;
		var wrapperId = 'ProductCardImageWrapper-' + data.id;
		var imageStyle = '';
		if (images.length > 0) {
			var image = images[0];
			var width = boostPFSConfig.custom.max_height;
			var height = boostPFSConfig.custom.max_height;
			var aspect_ratio = image.width / image.height;
			var small_style = true;
			var container_aspect_ratio = width * 1.0 / height;

			if (image.aspect_ratio < 1.0) {
				var maximum_width = height * aspect_ratio;
				if (image.height <= height) {
					var maximum_height = image.height;
					maximum_width = image.width;
				} else {
					var maximum_height = height;
				}
			} else if (aspect_ratio < container_aspect_ratio) {
				var maximum_height = height / aspect_ratio;
				if (image.height <= height) {
					var maximum_height = image.height;
					var maximum_width = image.width;
				} else {
					var maximum_height = height;
					var maximum_width = height * aspect_ratio;
				}
			} else {
				var maximum_height = height / aspect_ratio;
				if (image.width <= width) {
					maximum_height = image.height;
					var maximum_width = image.width
				} else {
					var maximum_width = width;
					maximum_height = maximum_width / aspect_ratio;
				}
			}

			imageStyle += '<style>';
			if (small_style) imageStyle += '@media screen and (min-width: 750px) {';
			imageStyle += '#' + imgId + ' {' +
				'max-width: ' + maximum_width + 'px;' +
				'max-height: ' + maximum_height + 'px;' +
				'}' +
				'#' + wrapperId + ' {' +
				'max-width: ' + maximum_width + 'px;' +
				'max-height: ' + maximum_height + 'px;' +
				'}';
			if (small_style) imageStyle += '}';

			if (small_style) {
				if (aspect_ratio < 1) {
					maximum_width = 750 * aspect_ratio;
				} else {
					if (image.width < 750) {
						maximum_width = image.width;
					} else {
						maximum_width = 750;
					}
				}
				imageStyle += '@media screen and (max-width: 749px) {'
				imageStyle += '#' + imgId + ' {' +
					'max-width: ' + maximum_width + 'px;' +
					'max-height: 750px;' +
					'}' +
					'#' + wrapperId + ' {' +
					'max-width: ' + maximum_width + 'px;' +
					'}';
				imageStyle += '}';
			}
			imageStyle += '</style>';
		}
		return imageStyle;
	}

	function buildPreorderIndicator(data) {
		let isPreorder = false;
		if (
			data
			&& data.variants
			&& data.variants[0]
			&& data.variants[0].inventory_quantity <= 0
			&& data.variants[0].inventory_policy === 'continue'
			&& !window.disablePreorder
		) {
			isPreorder = true;
		}
		var html = '';
		if(data.available) {
			if(data['variants'].length > 1) {
				html = '<input type="hidden" name="View Details" class="View Details" value="1" />';
			} else {
				if(isPreorder) {
					html = '<input type="hidden" name="Add to Cart" class="Pre-Order" value="1" />';
				} else {
					html = '<input type="hidden" name="Add to Cart" class="Add to Cart" value="1" />';
				}
			}
		} else {
			html = '<input type="hidden" name="Out of Stock" class="Out of Stock" value="1" />';
		}
		return html;
	}

	function buildSpecialOrder(data) {
		var html = '';
		var productTags = data.tags;
		productTags.forEach(function(item) {
			if (item == 'special-order') {
				html = '<div class="special-order-badge">' +
					'SPECIAL ORDER' +
					'</div>';
			}
		});
		return html;
	}

	function buildPrice(data, onSale, priceVaries) {
		var priceHtml = '',
			onSaleClass = onSale ? ' price--on-sale' : '';
		var soldOutClass = data.available ? '' : ' price--sold-out';
		var comparePriceVaries = data.compare_at_price_min != data.compare_at_price_max;
		var priceVariesClass = !priceVaries && comparePriceVaries ? ' price--compare-price-hidden' : '',
			variant = data.variants[0],
			unitPriceMeasurementClass = '',
			unitPriceSeparatorHtml = '',
			unitPirceBaseUnitHtml = '';

		if (variant.hasOwnProperty('unit_price_measurement')) {
			unitPriceMeasurementClass = ' price--unit-available';
		}

		priceHtml += '<dl class="price price--listing' + onSaleClass + soldOutClass + priceVariesClass + unitPriceMeasurementClass + '" data-price>';
		if (boostPFSConfig.custom.hasOwnProperty('vendor_enable') && boostPFSConfig.custom.vendor_enable == true) {
			priceHtml += '<div class="price__vendor price__vendor--listing"><dt>';
			priceHtml += '<span class="visually-hidden">' + boostPFSConfig.label.vendor + '</span>';
			priceHtml += '</dt><dd>';
			priceHtml += data.vendor;
			priceHtml += '</dd></div>';
		}

		priceHtml += '<div class="price__regular">';
		priceHtml += '<dt><span class="visually-hidden visually-hidden--inline">' + boostPFSConfig.label.regular_price + '</span>';
		priceHtml += '</dt><dd>';
		priceHtml += '<span class="price-item price-item--regular" data-regular-price>';
		if (priceVaries) {
			priceHtml += boostPFSConfig.label.from_lowest_price_html.replace(/{{ lowest_price }}/, Utils.formatMoney(data.price_min));
		} else {
			priceHtml += Utils.formatMoney(data.price_min);
		}
		priceHtml += '</span></dd></div>';

		priceHtml += '<div class="price__sale"> <dt> <span class="visually-hidden visually-hidden--inline">';
		priceHtml += boostPFSConfig.label.sale_price +
			'</span></dt>';
		priceHtml += '<dd> <span class="price-item price-item--sale">';
		if (priceVaries) {
			priceHtml += boostPFSConfig.label.from_lowest_price_html.replace(/{{ lowest_price }}/, Utils.formatMoney(data.price_min));
		} else {
			priceHtml += Utils.formatMoney(data.price_min);
		}
		priceHtml += '</span></dd>';
		priceHtml += '<div class="price__compare"> <dt> <span class="visually-hidden visually-hidden--inline">';
		priceHtml += boostPFSConfig.label.regular_price;
		priceHtml += '</span></dt>';
		priceHtml += '<dd> <s class="price-item price-item--regular">';
		priceHtml += Utils.formatMoney(data.compare_at_price_min);
		priceHtml += '</s></dd></div>';
		priceHtml += '</div>';

		priceHtml += '<div class="price__unit"> <dt> <span class="visually-hidden visually-hidden--inline">';
		priceHtml += boostPFSConfig.label.unit_price_label;
		priceHtml += '</span></dt>';
		priceHtml += '<dd class="price-unit-price">';

		unitPriceSeparatorHtml += '<span aria-hidden="true">/</span><span class="visually-hidden">';
		unitPriceSeparatorHtml += boostPFSConfig.label.unit_price_separator + '&nbsp;</span>';

		if (variant.hasOwnProperty('unit_price_measurement') && variant.unit_price_measurement) {
			unitPirceBaseUnitHtml += '<span>';
			if (variant.hasOwnProperty('reference_value') && variant.unit_price_measurement.reference_value != 1) {
				unitPirceBaseUnitHtml += variant.unit_price_measurement.reference_value;
			}
			if (variant.hasOwnProperty('reference_unit')) {
				unitPirceBaseUnitHtml += variant.unit_price_measurement.reference_unit;
			}
			unitPirceBaseUnitHtml += '</span>';
		}

		if (variant.hasOwnProperty('unit_price')) {
			priceHtml += '<span>' + Utils.formatMoney(variant.unit_price) + '</span>';
		}

		priceHtml += unitPriceSeparatorHtml + unitPirceBaseUnitHtml;
		priceHtml += '</dd></div>';

		priceHtml += '<div class="price__badges price__badges--listing">' +
			'<span class="price__badge price__badge--sale" aria-hidden="true"> <span>';
		priceHtml += boostPFSConfig.label.sale + '</span></span>';
		priceHtml += '<span class="price__badge price__badge--sold-out">' +
			boostPFSConfig.label.sold_out +
			'</span></span></div>';

		priceHtml += '</dl>';

		return priceHtml;
	}

	/// Build Pagination
	ProductPaginationDefault.prototype.compileTemplate = function(totalProduct) {
		if (!totalProduct) totalProduct = this.totalProduct;
		// Get page info
		var currentPage = parseInt(Globals.queryParams.page);
		var totalPage = Math.ceil(totalProduct / Globals.queryParams.limit);

		// If it has only one page, clear Pagination
		if (totalPage <= 1) {
			return '';
		}

		var paginationHtml = boostPFSTemplate.paginateHtml;

		// Build Previous
		var previousHtml = (currentPage > 1) ? boostPFSTemplate.previousActiveHtml : boostPFSTemplate.previousDisabledHtml;
		previousHtml = previousHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage - 1));
		paginationHtml = paginationHtml.replace(/{{previous}}/g, previousHtml);

		var currentPagination = '';
		if (totalPage <= 5) {
			for (var page = 1; page <= totalPage; page++) {
				currentPagination += this.pageString(page);
			}
		} else {
			var first_flag = false;
			var second_flag = false;
			var first_page = currentPage - 2;
			var second_page = currentPage - 1;
			if (first_page > 0) {
				currentPagination += this.pageString(first_page);
			} else {
				first_flag = true;
			}
			if (second_page > 0) {
				currentPagination += this.pageString(second_page);
			} else {
				second_flag = true;
			}
			/**
			 * Current page
			 */
			currentPagination += this.pageString(currentPage);
			var fourth_page = currentPage + 1;
			var fifth_page = currentPage + 2;

			/**
			 * Previous
			 */
			if (fourth_page < totalPage) {
				currentPagination += this.pageString(fourth_page);
			}
			if (fifth_page < totalPage) {
				currentPagination += this.pageString(fifth_page);
			}
			if (first_flag && ((totalPage - first_flag) > 0)) {
				currentPagination += this.pageString(fifth_page + 1);
			}
			if (second_flag && ((totalPage - first_flag) > 1)) {
				currentPagination += this.pageString(fifth_page + 2);
			}
		}
		// Build Next
		var nextHtml = (currentPage < totalPage) ? boostPFSTemplate.nextActiveHtml : boostPFSTemplate.nextDisabledHtml;
		nextHtml = nextHtml.replace(/{{itemUrl}}/g, Utils.buildToolbarLink('page', currentPage, currentPage + 1));
		paginationHtml = paginationHtml.replace(/{{next}}/g, nextHtml);

		// Build page items
		// var currentPage = boostPFSConfig.label.current_page.replace(/{{ current }}/g, currentPage).replace(/{{ total }}/g, totalPage);
		// paginationHtml = paginationHtml.replace(/{{pageItems}}/g, currentPage);
		paginationHtml = paginationHtml.replace(/{{pageItems}}/g, currentPagination);

		return paginationHtml;
	};
	ProductPaginationDefault.prototype.pageString = function (page) {
		var url = window.location.href.split('?')[0];
		var queryString = window.location.href.split('?')[1];
		var urlParams = new URLSearchParams(queryString);
		var current = urlParams.get('page');
		if (!current) {
			current = 1;
		}
		if (!queryString) {
			var page_url = url + '?page=' + page;
		} else {
			var page_url = url + '?page=' + page + '&'+queryString ;
		}
		var selected = '';
		if (page == current) {
			selected = 'ais-Pagination-item--selected';
		}
		return '<li class="ais-Pagination-item--page ' + selected + '"><a class="ais-Pagination-link" href="' + page_url + '" aria-label="' + page + '" >' + page + '</a></li>';
	}

	// Build Sorting
	ProductSorting.prototype.compileTemplate = function() {
		var html = '';
		if (boostPFSTemplate.hasOwnProperty('sortingHtml')) {
			var sortingArr = Utils.getSortingList();
			if (sortingArr) {
				// Build content
				var sortingItemsHtml = '';
				for (var k in sortingArr) {
					if(k != 'created-descending' && k != 'created-ascending') {
						sortingItemsHtml += '<option value="' + k + '">' + sortingArr[k] + '</option>';
					}
				}
				html = boostPFSTemplate.sortingHtml.replace(/{{sortingItems}}/g, sortingItemsHtml);
			}
		}
		return html;
	};

	// Build Display type
	ProductDisplayType.prototype.compileTemplate = function() {
		var itemHtml = '<span>View As </span>';
		itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'list', 'grid') + '" title="Grid view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-grid" data-view="grid"><span class="icon-fallback-text"><span class="fallback-text">Grid view</span></span></a>';
		itemHtml += '<a href="' + Utils.buildToolbarLink('display', 'grid', 'list') + '" title="List view" class="{{class.productDisplayType}}-item {{class.productDisplayType}}-list" data-view="list"><span class="icon-fallback-text"><span class="fallback-text">List view</span></span></a>';
		itemHtml = itemHtml.replace(/{{class.productDisplayType}}/g, Class.productDisplayType);

		return itemHtml;
	};

	// Add additional feature for product list, used commonly in customizing product list
	ProductList.prototype.afterRender = function(data) {
		if (!data) data = this.data;
		var productSelector = jQ(Selector.products);
		if (Globals.queryParams.display == 'list') {
			if (productSelector.children('.list-view-items').length == 0) {
				productSelector.children().wrapAll('<ul class="list-view-items"></ul>');
			}
			productSelector.removeClass('grid grid--uniform grid--view-items');
		} else {
			if (productSelector.children('.list-view-items').length > 0) {
				productSelector.children('.list-view-items').children().unwrap();
			}
			productSelector.addClass('grid grid--uniform grid--view-items');
		}


		// Render Image OverLay App
         if(document.getElementsByClassName('easyOverlayImage').length>0){
            let product_id_arr = [];
            for(let i=0; i<document.getElementsByClassName('easyOverlayImage').length; i++){
                let i_elem = document.getElementsByClassName('easyOverlayImage')[i];
                let pro_id = i_elem.dataset.product_id;
                product_id_arr.push(pro_id);
            }

            if (typeof eo_api_url !== 'undefined' && typeof createOverlayHtml !== 'undefined') {
                var url = eo_api_url+'/shop_product_overlays?shop='+Shopify.shop;
                url += '&product_ids='+product_id_arr.join(',');
                url += '&page=collection';

                $.ajax({
                    type: 'GET',
                    url: url,
                    dataType: 'json',
                    success: function(data) {
                      const content = data;
                      if(content.data != undefined && content.data.length>0){
                        content.data.forEach(function(item, index) {
                        createOverlayHtml(item);
                      });
                     }
                    // JSON.stringify({'shop': Shopify.shop, 'product_ids': product_id_arr.join(',')})
                    }
                });
            }
        }
	}

	// Build Additional Elements
	FilterResult.prototype.afterRender = function(data, eventType) {
		if (!data) data = this.data;
		var totalProduct = '';
		if (data.total_product == 1) {
			totalProduct = boostPFSConfig.label.items_with_count_one.replace(/{{ count }}/g, data.total_product);
		} else {
			totalProduct = boostPFSConfig.label.items_with_count_other.replace(/{{ count }}/g, data.total_product);
		}
		jQ('.boost-pfs-filter-total-product').html(totalProduct);
	};

  	BoostOTP.inject(this);
  	BoostOTP.AddToCart.prototype.getTemplate = function() {
		if(Utils.isMobile()) {
          return `<form method="post" action="/cart/add" accept-charset="UTF-8" class="{{class.atcForm}}" enctype="multipart/form-data" data-href="{{productUrl}}">
                <input type="hidden" name="form_type" value="product">
                <div class="js_add_tc"><select name="quantity">
                <option value="1">1</option>
                <option value="2">2</option>
                <option value="3">3</option>
                <option value="4">4</option>
                <option value="5">5</option>
                <option value="6">6</option>
                <option value="7">7</option>
                <option value="8">8</option>
                <option value="9">9</option>
                <option value="10">10</option>
                </select>
                </div>
                </option>
                <input type="hidden" name="id" value="{{variantId}}">
                <div class="boost-pfs-addtocart-wrapper">
                <button name="add" class="boost-pfs-addtocart-btn boost-pfs-addtocart-select-options js-ajax-ct"  data-id="{{variantId}}" {{clickAction}}>
                <span>{{icoCart}}{{label}}</span>
                </button>
                </div>
                </form>
                `.trim();
        }
        return `<form method="post" action="/cart/add" accept-charset="UTF-8" class="{{class.atcForm}}" enctype="multipart/form-data" data-href="{{productUrl}}">
        <input type="hidden" name="form_type" value="product">
        <div class="js_add_tc"><input type="number" name="quantity" value="1" min="1"></div>
        <input type="hidden" name="id" value="{{variantId}}">
        <div class="boost-pfs-addtocart-wrapper">
        <button name="add" class="boost-pfs-addtocart-btn boost-pfs-addtocart-select-options js-ajax-ct" data-id="{{variantId}}" data-special-order="{{specialOrderAttr}}" {{clickAction}}>
        <span>{{icoCart}}{{label}}</span>
        </button>
        </div>
        </form>`.trim();
	};

  	BoostOTP.AddToCart.prototype.compileTemplate = function() {
		var productUrl = Utils.buildProductItemUrl(this.parent.data);
		var clickAction = '';
		var label = '';
		var variantId = '';
		var buttonClass = '';
		var productData = this.parent.data;
		var productListData = this.parent.parent.data;
		var productIsFirst = productData.id == productListData[0].id;
		var specialOrderAttr = false;
		var productTags = productData.tags;
      	//console.log(productData);

		var icoCart = Settings.getSettingValue('general.icoCart');

		var icoCartLink = Settings.getSettingValue('general.icoCartLink');

		if (productData.available) {
			if (productData.variants.length == 1) {
				// Buy now if have 1 variant
				clickAction = Settings.getSettingValue('general.enableAjaxCart') ? '' : 'type="submit"';
				variantId = productData.variants[0].id;
				label = Labels.action_list.atcAvailableLabel;
				buttonClass = Class.atcAvailable;
				// this.type = AddToCart.Type.ADD_TO_CART;
				this.variantId = variantId;
			} else {
				// Select options (link to product page) if have > 1 variant
				clickAction = 'onclick="window.location.href=\'' + productUrl + '\'" type="button"';
				label = Labels.action_list.atcSelectOptionsLabel;
				buttonClass = Class.atcSelectOptions;
				// this.type = AddToCart.Type.SELECT_OPTIONS;
			}
			productTags.forEach(function(item) {
				if (item == 'special-order') {
					specialOrderAttr = true;
				}
			});
		} else {
			clickAction = 'disabled type="button"';
			label = Labels.action_list.atcSoldOutLabel;
			buttonClass = Class.atcSoldOut;
			this.type = AddToCart.Type.SOLD_OUT;
		}

		return this.getTemplate()
			.replace(/{{class.atcForm}}/g, Class.atcForm)
			.replace(/{{label}}/g, label)
			.replace(/{{variantId}}/g, variantId)
			.replace(/{{clickAction}}/g, clickAction)
			.replace(/{{buttonClass}}/g, buttonClass)
			.replace(/{{productUrl}}/g, productUrl)
			.replace(/{{icoCart}}/g, productIsFirst ? icoCart : icoCartLink)
			.replace(/{{specialOrderAttr}}/g, specialOrderAttr)
	}
  BoostOTP.AjaxCart.prototype.onSucess = function(data, $addingLabel, $errorLabel) {
    this.changeButtonLabel($addingLabel, Labels.action_list.atcAddingToCartBtnLabel, Labels.action_list.atcAddedToCartBtnLabel);
    setTimeout(() => {
      this.changeButtonLabel($addingLabel, Labels.action_list.atcAddedToCartBtnLabel, Labels.action_list.atcAvailableLabel);
    }, 700);
    var isOpenCart = Settings.getSettingValue('general.showAjaxCartOnAdd');
    jQ('.site-header__cart').click();
  }

})();
